import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const countryApi = generateNomenApi<{ isoCode: string }>('/nomen/country');

export const countryOptions = generateNomenOptions('country', countryApi);
